import { html, type TemplateResult } from 'lit-html';

/** Icons from the Catch set (assets/icons/sprite.svg, upstream) and the few this app adds (acw-icons.svg). */
const CATCH = new Set([
  'add', 'edit', 'delete', 'duplicate', 'view', 'confirm', 'close', 'download', 'upload', 'filter', 'search', 'settings',
  'overview', 'home', 'users', 'vendors', 'reports', 'logs', 'notifications', 'test-post', 'logout', 'chevron', 'menu',
  'sun', 'moon', 'monitor',
]);
export type IconName = 'overview' | 'settings' | 'reports' | 'logs' | 'users' | 'logout' | 'chevron' | 'menu' | 'sun' | 'moon' | 'monitor'
  | 'timeouts' | 'queues' | 'exemptions' | 'guide';

/** Decorative by default: label the control that holds it (aria-label), not the icon. */
export function icon(name: IconName, cls = ''): TemplateResult {
  const file = CATCH.has(name) ? 'sprite.svg' : 'acw-icons.svg';
  return html`<svg class="icon ${cls}" aria-hidden="true" focusable="false"><use href="assets/icons/${file}#${name}"></use></svg>`;
}
